import { Private_Routes } from '@common/url';
import { Button, Stack, Text, theme } from '@prophecy/ui';
import styled from 'styled-components';

const Root = styled(Stack)`
  background: ${theme.colors.gray50};
  border: 1px solid ${theme.colors.gray200};
`;

export default function DeploymentHeader({ title }: { title: string }) {
  return (
    <Root padding={`${theme.spaces.x12} ${theme.spaces.x12}`} gap={theme.spaces.x2} align='center' width='100%'>
      <Stack direction='horizontal' alignY='center' align='space-between'>
        <Text weight={theme.fontWeight.medium} level='sm13' tone={theme.colors.gray700}>
          {title}
        </Text>
        <Button
          size='s'
          elementType='link'
          to={Private_Routes.Settings.tab.getUrl({ tab: 'deployment' })}
          variant='linkGray'
          data-test-id='deployment-header-cancel-button'>
          Cancel
        </Button>
      </Stack>
    </Root>
  );
}
